import api from "@/lib/api";

/** Configurable dropdown options (managed by coordinators in Lists & Options). */
export async function loadOptionLists() {
  const { data } = await api.get("/option-lists");
  return data;
}

export async function loadOptionList(key) {
  const { lists } = await loadOptionLists();
  return lists[key] || [];
}

export const optionLabels = (opts) => (opts || []).map((o) => o.label);
export const findOption = (opts, label) => (opts || []).find((o) => o.label === label);
